const product = () => {
    const selectors = {
        mainProductSection: '[data-main-product]',
        productHandle: 'data-product-handle',
        productInfo: '[data-product-info]',
        productAccordionBlock: '[data-product-accordion-block]',
        accordionTitle: '[data-accordion-title]',
        accordionContent: '[data-accordion-content]',
        openOnLoad: 'open-on-load',
    };
    const classes = {
        accordionOpen: 'product__accordion--open',
    };
    const mainProductSections = document.querySelectorAll(selectors.mainProductSection);
    mainProductSections.forEach((section) => {
        const productInfo = section.querySelector(selectors.productInfo);
        // Add to Recently Viewed
        const productHandle = section.getAttribute(selectors.productHandle);
        let viewedProducts = JSON.parse(sessionStorage.getItem('frank-green:recently-viewed-products'));
        if (!viewedProducts) {
            viewedProducts = [];
        }
        viewedProducts.push(productHandle);
        const uniqueViewedProducts = viewedProducts.filter((element, index) => {
            return viewedProducts.indexOf(element) === index;
        });
        sessionStorage.setItem('frank-green:recently-viewed-products', JSON.stringify(uniqueViewedProducts));
        // Accordions
        const openAccordion = (accordion) => {
            const content = accordion.querySelector(selectors.accordionContent);
            accordion.classList.add(classes.accordionOpen);
            content.style.maxHeight = content.scrollHeight + 'px';
        };
        const closeAccordion = (accordion) => {
            const content = accordion.querySelector(selectors.accordionContent);
            accordion.classList.remove(classes.accordionOpen);
            content.style.maxHeight = null;
        };
        const productAccordionBlocks = productInfo.querySelectorAll(selectors.productAccordionBlock);
        productAccordionBlocks.forEach((accordion) => {
            const title = accordion.querySelector(selectors.accordionTitle);
            const content = accordion.querySelector(selectors.accordionContent);
            if (content.hasAttribute(selectors.openOnLoad)) {
                content.style.maxHeight = content.scrollHeight + 'px';
            }
            if (title && content) {
                title.onclick = () => {
                    if (content.style.maxHeight) {
                        closeAccordion(accordion);
                        accordion.classList.remove(classes.accordionOpen);
                    }
                    else {
                        productAccordionBlocks.forEach((accordion) => closeAccordion(accordion));
                        openAccordion(accordion);
                        accordion.classList.add(classes.accordionOpen);
                        setTimeout(() => {
                            requestAnimationFrame(() => {
                                const rect = title.getBoundingClientRect();
                                const inView = rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
                                const scrollOffset = 100;
                                const scrollPosition = window.scrollY + rect.top - scrollOffset;
                                if (!inView) {
                                    window.scrollTo({
                                        top: scrollPosition,
                                        behavior: 'smooth',
                                    });
                                }
                            });
                        }, 400);
                    }
                };
            }
        });
        window.addEventListener('resize', () => {
            productAccordionBlocks.forEach((accordion) => {
                const content = accordion.querySelector(selectors.accordionContent);
                if (content && content.style.maxHeight) {
                    openAccordion(accordion);
                }
            });
        });
    });
};
export { product };
